const languages =
[
    'fr', 'en', 'it', 'es', 'de'
];

export default languages ;